import axios from 'axios';
import showErrorToast from '../../Components/Shared/ShowErrorToast.js';

import {
    SET_DAYLIGHT_CODES,
    SET_NEO_CODES,
    SET_INCOMING_NEO_CODES,
    TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL,
    DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW,
    DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW,
    DAYLIGHT_REMOVE_CODE_MAPPING,
    DAYLIGHT_MARK_CODE_COMPLETE,
    DAYLIGHT_UNMARK_CODE_COMPLETE,
    SET_DAYLIGHT_WORKING_PRACTICE,
    SET_DAYLIGHT_IS_LOADING_CODES,
    SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS,
    SET_DAYLIGHT_CODES_FILTER_CODE_NAME,
    SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY,
    SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION,
    SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION,
    SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING,
    SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS,
    SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED,
    SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW,
    SET_DAYLIGHT_UPDATING_CODE_ID,
    SET_DAYLIGHT_UPDATING_MAPPING_ID,
    SET_DAYLIGHT_TARGET_CODE_FOR_ACTION,
    SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN,
    SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN,
    SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION,
    SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL,
    SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS,
    SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN,
    ADD_DAYLIGHT_MAPPING,
    SET_DAYLIGHT_MAPPING,
    SET_DAYLIGHT_MAPPING_COMMENT,
    SET_DAYLIGHT_CODES_DISPLAYED_COUNT,
    SET_DAYLIGHT_CODE,
    SET_DAYLIGHT_SELECTED_PARTNER_ID,
} from '../ActionTypes';

const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const refreshCodes = (clearActionTargetCode = true) => {
        return async (dispatch, getState) => {
            const state = getState();
            const practiceId = state.daylight.practice.id;
            const partnerId = state.daylight.partnerIdFilter;
            try {
                dispatch(setIsLoadingCodes(true));
                const res = await dispatch(
                    getDaylightCodesNoFilters(practiceId, partnerId)
                );
                // practiceIsFinalized, daylightCodes,
                // daylightCodeCount, daylightTotalCodesCount
                // daylightCodeCategories, daylightLocations
                dispatch(setDaylightCodes(res.data));
                dispatch(setIsLoadingCodes(false));
                dispatch(setUpdatingCodeId(''));
                if (clearActionTargetCode) dispatch(setActionTargetCode({}));
            } catch (error) {
                dispatch(setIsLoadingCodes(false));
            }
        };
    };

    const setUpdatingCodeId = (codeId = '') => {
        return {
            type: SET_DAYLIGHT_UPDATING_CODE_ID,
            payload: codeId,
        };
    };

    const setUpdatingMappingId = (mappingId = '') => {
        return {
            type: SET_DAYLIGHT_UPDATING_MAPPING_ID,
            payload: mappingId,
        };
    };

    const setIsLoadingCodes = (bool) => {
        return {
            type: SET_DAYLIGHT_IS_LOADING_CODES,
            payload: bool,
        };
    };

    const clearDaylightCodeMapperState = () => {
        return (dispatch) => {
            dispatch(clearDaylightCodes());
            dispatch(clearIncomingNeoCodes());
            dispatch(setCodeNameFilter(''));
            dispatch(setCodeCategoryFilter(''));
            dispatch(setCodeDescriptionFilter(''));
            dispatch(setCodeMappingFilter(''));
            // setOnlyCodesForReview(false);
            // setAllCodesView(false);
        };
    };

    const setCodeNameFilter = (string = '') => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_NAME,
            payload: string,
        };
    };

    const setCodeCategoryFilter = (string = '') => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY,
            payload: string,
        };
    };

    const setCodeDescriptionFilter = (string = '') => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION,
            payload: string,
        };
    };

    const setCodeLocationFilter = (string = '') => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION,
            payload: string,
        };
    };

    const setCodeMappingFilter = (string = '') => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING,
            payload: string,
        };
    };

    const setCodeHasCommentsFilter = (state = null) => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS,
            payload: state,
        };
    };

    const setCodeIsMarkedCompletedFilter = (state = null) => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED,
            payload: state,
        };
    };

    const setCodeNeedsReviewFilter = (state = null) => {
        return {
            type: SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW,
            payload: state,
        };
    };

    const setDaylightCodeMapperPractice = (
        practiceId = '',
        practiceName = ''
    ) => {
        return {
            type: SET_DAYLIGHT_WORKING_PRACTICE,
            payload: { id: practiceId, name: practiceName },
        };
    };

    const toggleDaylightCodeReviewModal = (status = false) => {
        return async (dispatch) => {
            if (status) {
                dispatch(refreshCodes());
                dispatch(fetchIncomingNeoCodes());
            }
            dispatch(setDaylightCodeMappingModalOpen(status));
        };
    };

    const setDaylightCodeMappingModalOpen = (bool) => {
        return {
            type: TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL,
            status: bool,
        };
    };

    const setDaylightCodes = (codes) => {
        return {
            type: SET_DAYLIGHT_CODES,
            codes: codes,
        };
    };
    var CancelToken = axios.CancelToken;
    var cancelDaylightCodesRequest;
    const fetchDaylightCodes = (practiceId, onlyReview = false) => {
        return async (dispatch) => {
            try {
                if (cancelDaylightCodesRequest !== undefined)
                    cancelDaylightCodesRequest();
                var response = await axiosCall.get(
                    `daylight/${practiceId}/codes?onlyCodesForReview=${onlyReview}`,
                    {
                        cancelToken: new CancelToken(function executor(c) {
                            cancelDaylightCodesRequest = c;
                        }),
                    }
                );
                dispatch(setDaylightCodes(response.data.data));
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const getDaylightCodesNoFilters =
        (practiceId, partnerId = '') =>
        async () => {
            try {
                let url = `daylight/${practiceId}/allcodes`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                return await axiosCall.get(url);
            } catch (error) {
                console.error(error.message);
            }
        };

    const clearDaylightCodes = () => {
        return async (dispatch) => {
            dispatch(setDaylightCodes([]));
        };
    };

    const setNeoCodes = (codes) => {
        return {
            type: SET_NEO_CODES,
            codes: codes,
        };
    };

    const clearNeoCodes = () => {
        return {
            type: SET_NEO_CODES,
            codes: [],
        };
    };

    const fetchNeoCodes = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`daylight/nodes/codes`);
                dispatch(setNeoCodes(response.data.data));
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const setIncomingNeoCodes = (codes) => {
        return {
            type: SET_INCOMING_NEO_CODES,
            codes: codes,
        };
    };

    const clearIncomingNeoCodes = () => {
        return {
            type: SET_INCOMING_NEO_CODES,
            codes: [],
        };
    };

    const fetchIncomingNeoCodes = () => {
        return async (dispatch, getState) => {
            try {
                let state = getState();
                let partnerId = state.daylight.partnerIdFilter;
                let url = `daylight/incomingnodes/codes`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }

                var response = await axiosCall.get(url);
                dispatch(setIncomingNeoCodes(response.data.data));
            } catch (error) {
                if (
                    error.response &&
                    error.response.data.message
                        .toLowerCase()
                        .indexOf('missing partner taxonomy configuration') !==
                        -1
                ) {
                    showErrorToast(
                        'Missing partner configuration. Please contact support.'
                    );
                }
            }
        };
    };

    const setActionTargetCode = (code = {}) => {
        return {
            type: SET_DAYLIGHT_TARGET_CODE_FOR_ACTION,
            payload: code,
        };
    };

    const setActionTargetMapping = (mapping = {}) => {
        return {
            type: SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION,
            payload: mapping,
        };
    };

    const setAddMappingModalOpen = (bool = false) => {
        return {
            type: SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN,
            payload: bool,
        };
    };

    const addDaylightMapping = (practiceId, partnerId, code, payload) => {
        return async (dispatch) => {
            try {
                const codeId = code.id;
                dispatch(addDaylightMappingLocal(codeId, payload));
                dispatch(setAddMappingModalOpen(false));

                let url = `daylight/${practiceId}/codes/${codeId}/add`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                const res = await axiosCall.post(url, payload);

                // update the code with the new mapping, really just the new mapping id
                // deep clone the code so we don't mutate the original incase we need to revert
                let updatedCode = JSON.parse(JSON.stringify(code));
                updatedCode.mappings.push(res.data.data);
                dispatch(updateCodeLocal(updatedCode));
            } catch (error) {
                displayActionFailedToastForCode('add mapping', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            }
        };
    };

    const addDaylightMappingLocal = (targetCodeId, payload) => {
        return {
            type: ADD_DAYLIGHT_MAPPING,
            targetCodeId,
            payload,
        };
    };

    const setEditMappingModalOpen = (bool = false) => {
        return {
            type: SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN,
            payload: bool,
        };
    };

    const editDaylightMapping = (
        practiceId,
        partnerId,
        code,
        mappingId,
        payload
    ) => {
        return async (dispatch) => {
            try {
                dispatch(setUpdatingMappingId(mappingId));
                const codeId = code.id;
                dispatch(setEditMappingModalOpen(false));
                dispatch(editDaylightMappingLocal(codeId, payload));
                let url = `daylight/${practiceId}/codes/${codeId}/edit`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                await axiosCall.post(url, payload);
            } catch (error) {
                displayActionFailedToastForCode('edit mapping', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            } finally {
                dispatch(setActionTargetCode({}));
                dispatch(setActionTargetMapping({}));
                dispatch(setUpdatingMappingId(''));
            }
        };
    };

    const editDaylightMappingWithComments = (
        practiceId,
        partnerId,
        code,
        mappingId,
        payload
    ) => {
        return async (dispatch) => {
            try {
                dispatch(setUpdatingMappingId(mappingId));
                const codeId = code.id;
                dispatch(setEditMappingModalOpen(false));
                dispatch(editDaylightMappingLocal(codeId, payload));
                let url = `daylight/${practiceId}/codes/${codeId}/editwithcomments`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }

                await axiosCall.post(url, payload);
            } catch (error) {
                displayActionFailedToastForCode('edit mapping', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            } finally {
                dispatch(setActionTargetCode({}));
                dispatch(setActionTargetMapping({}));
                dispatch(setUpdatingMappingId(''));
            }
        };
    };

    const editDaylightMappingLocal = (targetCodeId, payload) => {
        return {
            type: SET_DAYLIGHT_MAPPING,
            targetCodeId,
            payload,
        };
    };

    const deleteDaylightMapping = (
        practiceId,
        partnerId,
        codes,
        targetCode,
        targetMapping,
        payload
    ) => {
        return async (dispatch) => {
            try {
                dispatch(
                    deleteDaylightMappingLocal(codes, targetCode, targetMapping)
                );
                let url = `daylight/${practiceId}/codes/${targetCode.id}/delete`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }

                await axiosCall.delete(url, { data: payload });
            } catch (error) {
                displayActionFailedToastForCode('delete mapping', targetCode);

                //reset to original state
                dispatch(updateCodeLocal(targetCode));
            }
        };
    };

    const deleteDaylightMappingLocal = (codes, targetCode, targetMapping) => {
        return {
            type: DAYLIGHT_REMOVE_CODE_MAPPING,
            codes,
            targetCode,
            targetMapping,
        };
    };

    const exportDaylightCodes = (
        practiceId,
        partnerId,
        practiceName = `CodeExport.csv`
    ) => {
        return async (dispatch) => {
            try {
                //await axiosCall.get(`daylight/${practiceId}/codes/export`, {});
                let url = `daylight/${practiceId}/codes/export`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                await axiosCall({
                    url: url, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', practiceName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const markCodeComplete = (practiceId, code, partnerId) => {
        return async (dispatch) => {
            try {
                const targetCodeId = code.id;

                dispatch(setUpdatingCodeId(targetCodeId));
                dispatch(markCodeCompleteLocal(targetCodeId));
                let payload = new FormData();
                payload.append('confirmationStatus', 1);
                let url = `daylight/${practiceId}/codes/${targetCodeId}/confirmationstatus`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                await axiosCall.patch(url, payload);
            } catch (error) {
                displayActionFailedToastForCode('mark complete', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            } finally {
                dispatch(setUpdatingCodeId(''));
            }
        };
    };

    const markCodeCompleteLocal = (targetCodeId) => {
        return {
            type: DAYLIGHT_MARK_CODE_COMPLETE,
            targetCodeId,
        };
    };

    const unmarkCodeComplete = (practiceId, code, partnerId) => {
        return async (dispatch) => {
            try {
                const targetCodeId = code.id;

                dispatch(setUpdatingCodeId(targetCodeId));
                dispatch(unmarkCodeCompleteLocal(targetCodeId));
                let payload = new FormData();
                payload.append('confirmationStatus', 0);
                let url = `daylight/${practiceId}/codes/${targetCodeId}/confirmationstatus`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                await axiosCall.patch(url, payload);
            } catch (error) {
                displayActionFailedToastForCode('unmark complete', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            } finally {
                dispatch(setUpdatingCodeId(''));
            }
        };
    };

    const unmarkCodeCompleteLocal = (targetCodeId) => {
        return {
            type: DAYLIGHT_UNMARK_CODE_COMPLETE,
            targetCodeId,
        };
    };

    const markCodeForReview = (practiceId, targetCode, partnerId) => {
        return async (dispatch) => {
            try {
                const targetCodeId = targetCode.id;
                dispatch(setUpdatingCodeId(targetCodeId));
                dispatch(markCodeForReviewLocal(targetCodeId));
                let url = `daylight/${practiceId}/codes/${targetCodeId}/mark`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }

                await axiosCall.post(url);
            } catch (error) {
                displayActionFailedToastForCode('mark for review', targetCode);

                //reset to original state
                dispatch(updateCodeLocal(targetCode));
            } finally {
                dispatch(setUpdatingCodeId(''));
            }
        };
    };

    const markCodeForReviewLocal = (targetCodeId) => {
        return {
            type: DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW,
            targetCodeId,
        };
    };

    const unmarkCodeForReview = (practiceId, targetCode, partnerId) => {
        return async (dispatch) => {
            try {
                const targetCodeId = targetCode.id;
                dispatch(setUpdatingCodeId(targetCodeId));
                dispatch(unmarkCodeForReviewLocal(targetCodeId));
                let url = `daylight/${practiceId}/codes/${targetCodeId}/unmark`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }

                await axiosCall.delete(url);
            } catch (error) {
                displayActionFailedToastForCode('confirm mappings', targetCode);

                //reset to original state
                dispatch(updateCodeLocal(targetCode));
            } finally {
                dispatch(setUpdatingCodeId(''));
            }
        };
    };

    const unmarkCodeForReviewLocal = (targetCodeId) => {
        return {
            type: DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW,
            targetCodeId,
        };
    };

    const markCodeAsDisabled = (practiceId, targetCode, partnerId) => {
        return async (dispatch) => {
            try {
                const targetCodeId = targetCode.id;
                dispatch(setUpdatingCodeId(targetCodeId));

                var url = `daylight/${practiceId}/codes/${targetCodeId}/disable`;
                if (partnerId) {
                    url += `?partnerId=${partnerId}`;
                }
                await axiosCall.post(url);

                await dispatch(refreshCodes());
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    showErrorToast(
                        'A disabled mapping already exists for this code.'
                    );
                } else {
                    showErrorToast(
                        'Failed to disabled mapping. Please try again'
                    );
                }
            } finally {
                dispatch(setUpdatingCodeId(''));
            }
        };
    };

    const finalizePractice = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`daylight/${practiceId}/finalize`);
                dispatch(setPracticeIsFinalized(true));
                dispatch(refreshCodes());
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const unfinalizePractice = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.delete(`daylight/${practiceId}/unfinalize`);
                dispatch(setPracticeIsFinalized(false));
                dispatch(refreshCodes());
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const setPracticeIsFinalized = (bool) => {
        return {
            type: SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS,
            payload: bool,
        };
    };

    const runCodeConverter = (id) => async () =>
        axiosCall.post('daylight/' + id + '/codeconverter');

    const fetchDaylightCodeUsageDetails = (practiceId) => {
        return async () => {
            try {
                var response = await axiosCall.get(
                    `daylight/${practiceId}/codeusagedetails`
                );
                return response.data;
            } catch (error) {
                console.error(error.message);
                return [];
            }
        };
    };

    const setSelectedCodeUsageDetail = (codeUsageDetail) => {
        return {
            type: SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL,
            payload: codeUsageDetail,
        };
    };

    const fetchDaylightUserHasAccessToUsageDetails = (practiceId) => {
        return async (dispatch) => {
            if (!practiceId) return;
            try {
                var response = await axiosCall.get(
                    `daylight/${practiceId}/codeusagedetails/hasaccess`
                );
                dispatch(setDaylightUserHasAccessToUsageDetails(response.data));
                return response.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const setDaylightUserHasAccessToUsageDetails = (bool) => {
        return {
            type: SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS,
            payload: bool,
        };
    };

    const setMappingCommentModalOpen = (bool) => {
        return {
            type: SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN,
            payload: bool,
        };
    };

    const updateCodeMappingComments = (
        practiceId,
        code,
        codeMappingId,
        comments
    ) => {
        return async (dispatch) => {
            try {
                dispatch(setUpdatingMappingId(codeMappingId));
                const codeId = code.id;
                if (codeId === undefined || codeMappingId === undefined) {
                    showErrorToast(`Failed to update comments`);
                    return;
                }
                const payload = { comments };
                dispatch(
                    updateCodeMappingCommentsLocal(
                        codeId,
                        codeMappingId,
                        comments
                    )
                );

                await axiosCall.post(
                    `daylight/${practiceId}/codeMappings/${codeMappingId}/comments`,
                    payload
                );
            } catch (error) {
                displayActionFailedToastForCode('update comments', code);

                //reset to original state
                dispatch(updateCodeLocal(code));
            } finally {
                dispatch(setUpdatingMappingId(''));
            }
        };
    };

    const updateCodeMappingCommentsLocal = (
        targetCodeId,
        targetMappingId,
        comments
    ) => {
        return {
            type: SET_DAYLIGHT_MAPPING_COMMENT,
            targetCodeId,
            targetMappingId,
            payload: comments,
        };
    };

    const setDisplayedCodesCount = (count) => {
        return {
            type: SET_DAYLIGHT_CODES_DISPLAYED_COUNT,
            payload: count,
        };
    };

    const displayActionFailedToastForCode = (action, code) => {
        const codeName = code.code || 'Unknown';
        const codeDesc = code.codeDescription || 'Unknown';
        showErrorToast(
            `Failed to ${action} for Code: ${codeName}|${codeDesc}. Please refresh the list and try again.`
        );
    };

    const updateCodeLocal = (code) => {
        return {
            type: SET_DAYLIGHT_CODE,
            payload: code,
        };
    };

    const setSelectedPartnerId = (partnerId) => {
        return {
            type: SET_DAYLIGHT_SELECTED_PARTNER_ID,
            payload: partnerId,
        };
    };

    return {
        setDaylightCodeMapperPractice,
        addDaylightMapping,
        clearDaylightCodeMapperState,
        clearDaylightCodes,
        clearIncomingNeoCodes,
        clearNeoCodes,
        deleteDaylightMapping,
        editDaylightMapping,
        exportDaylightCodes,
        getDaylightCodesNoFilters,
        fetchDaylightCodes,
        fetchIncomingNeoCodes,
        fetchNeoCodes,
        finalizePractice,
        markCodeComplete,
        markCodeForReview,
        markCodeAsDisabled,
        runCodeConverter,
        toggleDaylightCodeReviewModal,
        unfinalizePractice,
        unmarkCodeComplete,
        unmarkCodeForReview,
        setCodeNameFilter,
        setCodeCategoryFilter,
        setCodeDescriptionFilter,
        setCodeLocationFilter,
        setCodeMappingFilter,
        setCodeHasCommentsFilter,
        setCodeIsMarkedCompletedFilter,
        setCodeNeedsReviewFilter,
        setUpdatingCodeId,
        setActionTargetCode,
        setActionTargetMapping,
        setAddMappingModalOpen,
        setEditMappingModalOpen,
        refreshCodes,
        fetchDaylightCodeUsageDetails,
        setSelectedCodeUsageDetail,
        fetchDaylightUserHasAccessToUsageDetails,
        setMappingCommentModalOpen,
        updateCodeMappingComments,
        setDisplayedCodesCount,
        editDaylightMappingWithComments,
        setSelectedPartnerId,
    };
};

export default initActions;
